f<template>
    <div class="page bg-transfer-point relative desktop-footer">
        <div class="bg-head-coin hidden sm:block"></div>
        <div class="page-content sm:px-8 pb-10">
            <TopBar class="hidden sm:block" :modalController="modalController"></TopBar>
            <TopBarBack class="block sm:hidden bg-a-blue-1c3e95 rounded-t-25" :isShowPoint="false" routeBack="/profile"></TopBarBack>
            <MenuDesktop activeMenu="none"></MenuDesktop>
            <div class="mx-auto bg-white sm:rounded-25 text-center sm:mt-4 px-5">
                <div class="text-a-blue-1c3e95 text-24 pt-4">{{title}}</div>
                <div class="text-a-blue-1c3e95 text-22 pt-7">{{company}}</div>
                <div class="text-666666 text-22 pt-2">{{ detail }}</div>
                <div class="my-6 flex justify-center">
                    <a :href="'tel:' + phone">
                        <RedBtn class="w-56 h-45px">
                            <div class="flex justify-center">
                                <div><img class="w-3 pt-1" src="@/assets/icon/tel-icon.png"></div>
                                <div class="px-3">{{lbl.contactus.tel}} {{phone}}</div>
                            </div>
                        </RedBtn>
                    </a>

                </div>
                <div class="py-6 text-666666 text-22">
                    <div>{{lbl.contactus.day}}</div>
                    <div>{{lbl.contactus.time}}</div>
                </div>
                <div class="h-px bg-tc-gray-4 text-22 sm:mx-40"></div>
                <div class="my-4 text-tc-gray-3 text-22">หรือ</div>
                <div class="mx-6 mt-4 sm:pb-20">
                    <div class="flex justify-center mb-5">
                        <div class="w-56 h-45px text-20">
                            <button class="bg-a-blue-3b5998 border border-tc-blue-1 rounded-full text-white w-full h-45px text-20" @click="goToFacebookApp()">
                                <div class="flex items-center justify-center">
                                    <div>
                                        <img class="w-5" src="@/assets/social/facebook.svg">
                                    </div>
                                    <div class="text-20 ml-2">{{faceName}}</div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="flex justify-center">
                        <div class="w-56 text-20">
                            <GreenLineBtn customClass="h-45px" @click="goToLineApp()">
                                <div class="flex items-center justify-center">
                                    <div>
                                        <img class="w-5" src="@/assets/social/line.svg">
                                    </div>
                                    <div class="text-20 ml-2">{{lineName}}</div>
                                </div>
                            </GreenLineBtn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="block sm:hidden w-full">
            <div class="absolute left-0 right-0 bottom-1">
                <div class="flex justify-center">
                    <img class="w-40" src="@/assets/poer-tip.png">
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
//mixins
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//components
import TopBarBack from '@/components/Layout/TopBar/TopBarBack.vue';
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import RedBtn from '@/components/Button/RedBtn.vue';
import GreenLineBtn from '@/components/Button/GreenLineBtn.vue';
import ContactUsService from '../service/ContactService'
export default {
    name: 'TransferPoint',
    mixins: [ModalMixin, LocaleMixin],
    components:{
        TopBarBack,
        TopBar,
        MenuDesktop,
        BottomBar,
        RedBtn,
        GreenLineBtn
    },
    data() {
        return {
            facebook: '',
            faceName: '',
            line: '',
            lineName: '',
            company: '',
            detail: '',
            phone: '',
            title: ''
        };
    },

    created: async function() {
        await this.getBlobContactUs()
    },

    methods: {
        getBlobContactUs: function(){
            return new Promise((resolve) => {
                ContactUsService.apiGetContactUs()
                    .subscribe({
                        next: (res) => {
                            this.facebook = res.address.fb_link;
                            this.faceName= res.address.fb_name;
                            this.lineName = res.address.line_name;
                            this.line = res.address.line_link;
                            this.company = res.address.company
                            this.detail = res.address.detail
                            this.phone = res.address.phone
                            this.title = res.address.title
                            console.log(res)
                            resolve(true);
                        },
                        error: (err) => {
                            console.log(err)
                            resolve(null);
                        }
                    });
            });
        },
        goToLineApp: function(){
            window.location.href = this.line;
        },
        goToFacebookApp: function(){
            window.location.href = this.facebook;
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
.bg-transfer-point {
    background-image: linear-gradient(to bottom, #1c3e95 2%, #1c3d91 2%, #1a326e 16%);
    @include mobile {
        // background-color: #e9ecf5;
        background-color: white;
        background-image: none;
    }
}
.logo-padding{
    padding-top: 15%
}
</style>

